import { render } from "./IconFloorPlan.vue?vue&type=template&id=051dafcf"
import script from "./IconFloorPlan.vue?vue&type=script&lang=js"
export * from "./IconFloorPlan.vue?vue&type=script&lang=js"
script.render = render

export default script